import app from 'firebase/compat/app';

// Dev hits the local Functions emulator on Skyway's dedicated port (5051) — see
// skyway-functions/firebase.json. Moved off the default 5001 so it never clashes
// with other apps' emulators running on this machine.
const urlBase = process.env.NODE_ENV === 'development'
  ? 'http://localhost:5051/skyway-dev-373d5/us-central1/'
  : 'https://us-central1-skyway-dev-373d5.cloudfunctions.net/'

// Our functions answer failures with a JSON body ({success:false, error}) even on
// 4xx/5xx. Throwing the bare statusText discarded that reason and every caller
// showed a generic "failed" toast, so read the body first and keep the message.
const errorFromResponse = async (response) => {
  try {
    const body = await response.json();
    if (body && body.error) return { success: false, error: body.error };
  } catch (e) {
    // Non-JSON body (HTML error page, empty 500) — fall through to statusText.
  }
  return { success: false, error: response.statusText || `Request failed (${response.status})` };
};

const getAuthHeader = async () => {
  try {
    const user = app.auth && app.auth().currentUser;
    if (!user) return null;
    const token = await user.getIdToken();
    return token ? `Bearer ${token}` : null;
  } catch (e) {
    return null;
  }
};

const get = async params => {
  const initialValue = `${params.function || ''}?`;
  const paramsString = Object.keys(params.variables || {}).reduce(
    (string, key) => `${string}${key}=${params.variables[key]}&`, initialValue
  );
  const url = `${params.url || urlBase}${paramsString.slice(0, -1)}`;

  console.log(url);

  const headers = {};
  const authHeader = await getAuthHeader();
  if (authHeader) headers.Authorization = authHeader;

  return fetch(url, { headers })
    .then(async (response)=>{
      if(!response.ok){
        return await errorFromResponse(response);
      }
      return params.text ? response.text() : response.json();
    })
    .catch(e => {
      console.log(e)
      return {success: false, error: e?.message || String(e)}
    });
};

const post = async params => {
  const url = params.url || `${urlBase}${params.function}`;

  console.log(url);
  console.log(params.variables);

  const headers = {
    'Accept': 'application/json',
    'Content-Type': params.contentType || 'application/json',
  };
  const authHeader = await getAuthHeader();
  if (authHeader) headers.Authorization = authHeader;

  return fetch(url, {
      method: 'POST',
      headers,
      body: (!!params.contentType ? "data=" : '') + JSON.stringify(params.variables),
    })
    .then(async (response)=>{
      console.log(response);
      if(!response.ok){
        return await errorFromResponse(response);
      }
      return response.json();
    })
    .catch(e => {
      console.log(e)
      return {success: false, error: e?.message || String(e)}
    });
};

// Direct browser URL for the Jarvis check PDF proxy (getCheckPdf cloud
// function). The proxy holds the API key server-side and streams application/pdf,
// so this is safe to window.open in a new tab. Live-regenerated on each request.
export const getCheckPdfUrl = (checkId) => `${urlBase}getCheckPdf?checkId=${encodeURIComponent(checkId)}`;

// Direct browser URL for one stip document, built the same way the send builds it
// (previewStipDocument cloud function). The consignment agreement comes back with
// the NTO blacked out, so this is what the lender actually receives — unlike a
// Storage link, which is always the untouched original.
export const getStipDocumentUrl = (stockNumber, { key, fileId } = {}) => {
  const params = [`stockNumber=${encodeURIComponent(stockNumber)}`];
  if (key) params.push(`key=${encodeURIComponent(key)}`);
  if (fileId) params.push(`fileId=${encodeURIComponent(fileId)}`);
  return `${urlBase}previewStipDocument?${params.join('&')}`;
};

let RequestManager = {
  get,
  post,
};

export default RequestManager
